(() => {
  const bind = () => {
    const opener = document.querySelector('[data-dp-menu-open]');
    const menu = document.querySelector('#DepuffMenu');
    if (opener && menu && !opener.dataset.bound) {
      opener.dataset.bound = 'true';
      opener.addEventListener('click', () => { menu.showModal(); opener.setAttribute('aria-expanded', 'true'); });
      menu.querySelector('[data-dp-menu-close]').addEventListener('click', () => menu.close());
      menu.addEventListener('click', event => { if(event.target === menu && event.offsetX > menu.clientWidth) menu.close(); });
      menu.querySelectorAll('nav a').forEach(a=>a.addEventListener('click',()=>menu.close()));
      menu.addEventListener('close', () => { opener.setAttribute('aria-expanded', 'false'); opener.focus(); });
    }
    document.querySelectorAll('[data-dp-info]').forEach(button => {
      if(button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const dialog = document.querySelector('#DepuffInfo');
        dialog.querySelector('h2').textContent = button.textContent.trim();
        dialog.querySelector('p').textContent = button.dataset.dpInfo;
        dialog.showModal();
      });
    });
    document.querySelectorAll('[data-dp-dialog-close]').forEach(button => {
      if(button.dataset.bound) return; button.dataset.bound='true';
      button.addEventListener('click',()=>button.closest('dialog').close());
    });
  };
  bind(); document.addEventListener('shopify:section:load', bind);
  if (!window.depuffCartListenerBound) {
    window.depuffCartListenerBound = true;
    document.addEventListener('depuff:cart-added', async () => {
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers: {Accept: 'application/json'}});
        if (!response.ok) return;
        const cart = await response.json();
        const link = document.querySelector('.dp-header a[aria-label^="Shopping bag"]');
        if (link) {
          link.setAttribute('aria-label', `Shopping bag, ${cart.item_count} items`);
          let badge = link.querySelector('.dp-cart-count');
          if (!badge) {badge = document.createElement('span'); badge.className = 'dp-cart-count'; link.append(badge);}
          badge.textContent = cart.item_count; badge.hidden = !cart.item_count;
        }
        const count = document.querySelector('#DepuffMenu nav a:last-child span');
        if (count) count.textContent = cart.item_count;
      } catch (_) { /* The confirmed add-to-cart result and bag link remain usable. */ }
    });
  }
})();
